<template>
  <div>
    <div class="row">
      <div class="col-12 debug-panel">
        <p v-if="debug" class="thumb"><i class="fa fa-thumbs-up"></i> Troubleshooting / Debug is <strong>ON</strong></p>
        <p v-else class="thumb"><i class="fa fa-thumbs-down"></i> Troubleshooting / Debug is <strong>OFF</strong></p>
        <button v-on:click="toggleDebug" type="button" class="btn  btn-turquois btn-turquois ripple"><i class="fa fa-code"></i> Toggle Troubleshooting / Debug</button>
      </div>
    </div>

    <div v-if="debug">

      <hr>

      <div  class="row">
        <div class="col-12 debug-panel">
          <button @click="uploadLocalStorage" type="button" class="btn  btn-turquois qm-survey-edit-button"><i class="fa fa-upload"></i> Upload Local Storage to Server</button>
          <div v-if="uploadSuccess" class="debug-success"><i class="fa fa-check-circle"></i> LocalStorage uploaded to server</div>
          <br /><br />
        </div>
        <div class="col-12 debug-panel">
          <button @click="downloadLocalStorage" type="button" class="btn  btn-turquois qm-survey-edit-button"><i class="fa fa-download"></i> Download Local Storage as ZIP</button>
          <div v-if="downloadReady" class="debug-success"><i class="fa fa-check-circle"></i> LocalStorage ZIP ready</div>
        </div>
      </div>

      <hr>

      <div v-if="sudo || (username === 'ditoy') || (username === 'KellerM')" class="col-12 mt-5 debug-panel">
        <h2>Sudo</h2>
        <div v-if="sudo" class="col-12 mt-5 debug-panel">
          <span>{{ username }}</span>
          <button v-on:click="unSudo" type="button" class="btn mt-3 btn-turquois qm-survey-edit-button">Unsudo</button>
        </div>
        <div v-else>
          <form v-on:submit.prevent="doSudo">
            <div class="form-group row">
              <label for="username">Username</label>
              <input id="username" v-model="usernameInput" type="text" class="form-control">
              <button v-on:click="doSudo" type="button" class="btn mb-3 btn-turquois qm-survey-edit-button"><i class="fa fa-lock"></i></button>
            </div>
          </form>
        </div>
        <div v-if="sudo" class="col-12 mt-5 debug-panel">
          <div class="qm-panel qm-panel-left">
            <h2>Admin</h2>
            <form v-on:submit.prevent="unDeleteSurvey">
              <div class="form-group row">
                <label for="undeleteSurveyId" class="col-12 col-form-label">Survey Id (inspect localstorage)</label>
                <div class="col-12">
                  <input id="undeleteSurveyId" v-model="undeleteSurveyId" type="text" class="form-control">
                  <button v-on:click="unDeleteSurvey" type="button" class="btn mt-3 btn-turquois qm-survey-edit-button">Undelete survey</button><br />
                </div>
              </div>
            </form>
            <form v-on:submit.prevent="unDeleteSurvey">
              <div class="form-group row">
                <label for="undeleteSurveyId" class="col-12 col-form-label">Survey Id (inspect localstorage)</label>
                <div class="col-12">
                  <input id="reopenSurveyId" v-model="reopenSurveyId" type="text" class="form-control">
                  <button v-on:click="reopenSurveyById" type="button" class="btn mt-3 btn-turquois qm-survey-edit-button">Reopen survey</button><br />
                </div>
              </div>
            </form>
            <div v-if="username !== ''">
              <button v-on:click="reopenSurveys" type="button" class="btn btn-warning qm-survey-edit-button"><i class="fa fa-info-circle"></i> Reopen Surveys (of {{ session.username }})</button>
              <div v-if="reopenIdSuccess" class="debug-success"><i class="fa fa-check-circle"></i> Surveys reopened</div>
              <br /><br />
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-danger">

        <h2>DANGER ZONE</h2>

        <p>
          By resetting the local storage, you are irrevocably deleting all local data in your app. Only use this function in extreme circumstances
          when nothing else works, and only after safeguarding a copy of the local storage by either uploading it to the server or downloading a
          copy as a ZIP file.
        </p>

        <div class="row">
          <div class="col-12 debug-panel">
            <h2>Reset Local Storage</h2>
            <div v-if="hasClosedSurveys">
              <div class="alert alert-danger">
                <p>
                  You have closed surveys that have not been exported to the server yet. Please export closed surveys before
                  resetting the local storage. In case of doubt, please contact your IT support.
                </p>
              </div>
            </div>
            <div v-else>
              <button v-on:click="clearLocalStorage" type="button" class="btn btn-danger qm-survey-edit-button ripple"><i class="fa fa-fw fa-times"></i> Clear Local Storage</button>
              <div v-if="storageCleared" class="debug-success"><i class="fa fa-check-circle"></i> LocalStorage has been cleared</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  hr {
    margin: 2em 0;
  }

  h2 {
    color: red;
    font-weight: 700;
  }

  .row {
    margin: 1em 0;
  }
</style>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import filesaver from 'filesaver.js'

  export default {
    name: 'Debug',
    data () {
      return {
        debug: null,
        sudoUsername: '', // original username when in sudo mode
        sudo: false,
        username: '', // the username used as the surveyor
        usernameInput: '',
        undeleteSurveyId: '',
        reopenSuccess: false,
        reopenSurveyId: '',
        reopenIdSuccess: false,
        uploadSuccess: false,
        downloadReady: false,
        storageClearActions: 0,
        storageCleared: false,
        hasClosedSurveys: false
      }
    },
    computed: {
      ...mapGetters({
        session: 'getSession'
      })
    },
    created: function () {
      this.$store.dispatch('loadSession').then(() => {
        this.debug = this.session.debug
        this.sudoUsername = this.session.sudoUsername
        this.sudo = (this.session.sudoUsername !== '')
        this.username = this.session.username
        let closedSurveys = this.$store.getters.getClosedSurveys
        this.hasClosedSurveys = (closedSurveys && closedSurveys.length > 0)
      })
    },
    methods: {
      toggleDebug () {
        this.$store.dispatch('setDebug', !this.debug).then(() => {
          this.debug = !this.debug
        })
      },
      reopenSurveys () {
        axios.request({
          url: this.$getApiHost() + '/survey/reopen/' + this.session.username,
          method: 'get',
          params: {
            token: this.session.token
          }
        }).then((response) => {
          if (response.data) {
            this.reopenSuccess = true
          }
        })
      },
      reopenSurveyById () {
        axios.request({
          url: this.$getApiHost() + '/survey/reopen/',
          method: 'post',
          data: {
            token: this.session.token,
            survey: this.reopenSurveyId
          }
        }).then((response) => {
          if (response.data) {
            this.reopenSuccess = true
          }
        })
      },
      uploadLocalStorage () {
        this.$store.getters.getLocalStorage(this).then((blob) => {
          let formData = new FormData() // eslint-disable-line no-undef
          formData.append('username', this.session.username)
          formData.append('file', blob, 'localStorage.zip')
          axios.request({
            url: this.$getApiHost() + '/debugger/localStorage',
            method: 'post',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((response) => {
            if (Boolean(response.data.upload) === true) {
              this.uploadSuccess = true
            }
          })
        })
      },
      downloadLocalStorage () {
        this.$store.getters.getLocalStorage(this).then((blob) => {
          filesaver.saveAs(blob, 'localstorage.zip')
          this.downloadReady = true
        })
      },
      clearLocalStorage () {
        this.storageCleared = false
        this.storageClearActions = 0
        const actions = [
          'clearSurveysStorage',
          'clearRoomsStorage',
          'clearItemsStorage',
          'clearSignaturesStorage',
          'clearFotosStorage',
          'clearResourcesStorage',
          'clearRoomNameStorage',
          'clearStandardSurveyItemsStorage',
          'clearModesStorage',
          'clearCountriesStorage',
          'clearCratesStorage',
          'clearLegalNotesStorage',
          'clearSessionStorage'
        ]
        actions.forEach((action) => {
          this.$store.dispatch(action).then(() => {
            console.log('cleared: ' + action)
            this.storageClearActions++
            if ((actions.length - 1) === this.storageClearActions) {
              this.storageCleared = true
            }
          })
        })
      },
      doSudo () {
        this.$store.dispatch('setSudoUsername', this.username).then(() => {
          this.$store.dispatch('setUsername', this.usernameInput).then(() => {
            this.sudoUsername = this.username
            this.username = this.usernameInput
            this.sudo = true
          })
        })
      },
      unSudo () {
        this.$store.dispatch('setUsername', this.sudoUsername).then(() => {
          this.$store.dispatch('setSudoUsername', '').then(() => {
            this.username = this.sudoUsername
            this.sudoUsername = ''
            this.sudo = false
          })
        })
      },
      unDeleteSurvey () {
        this.$store.dispatch('undeleteSurvey', this.undeleteSurveyId)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Debug.vue